<div header class="auth-header"></div>
<mat-spinner [diameter]="40"  *ngIf="!errorMessage"></mat-spinner>

<div class="login-error" *ngIf="errorMessage">
  <div class="error-container">
    <mat-icon>question_mark</mat-icon>
    <span>{{ errorMessage }}</span>
  </div>
</div>
